import upd from 'immutability-helper';

import { getIsMsgOutgoing } from 'widget/actions';
import * as Env from 'widget/env';

const useHandleMessage = (setMessageList: Env.SetState<Env.Message[]>) => {
  const updStatus = async (msg: Env.Message, accessToken: string) => {
    const isOutgoing = getIsMsgOutgoing(accessToken, msg);

    if (isOutgoing) return;

    setMessageList(prevValue =>
      upd(prevValue, {
        $apply: (msgs: Env.Message[]) =>
          msgs.map((item): Env.Message => ({ ...item, status: 'read' })),
      }),
    );
  };

  const handleMessage = (msg: Env.Message, accessToken: string) => {
    setMessageList(prevValue => {
      const index = prevValue.findIndex(item => item.id == msg.id);
      if (index > -1) return upd(prevValue, { [index]: { $set: msg } });

      return upd(prevValue, { $push: [msg] });
    });

    updStatus(msg, accessToken);
  };

  return handleMessage;
};

export default useHandleMessage;
